import React from 'react';
import { NJButton, NJIconButton, NJToastContainer } from '@engie-group/fluid-design-system-react';
import { useState, useEffect, useCallback } from 'react';
import { Flex, Table } from "antd";
import './AdminUsers.css';
import { apiGatewayConfig } from '../../../config';
import { invokeLambda, displayNetworkError } from '../../../api';
import { useOktaAuth } from "@okta/okta-react";
import { useUser } from '../../../context/UserContext';
import Loading from '../../../Loading';
import ModalAddUser from './ModalAddUser';
import ModalConfirmDelete from './ModalConfirmDelete';


const AdminUsers = ({ active }) => {

    const dataType = 'AdminUser';

    const userInfo = useUser();
    const { oktaAuth } = useOktaAuth();

    const [dataset, setDataset] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [deleteUserGid, setDeleteUserGid] = useState(null);

    const usersColumns = [
        {
            title: 'User GID',
            dataIndex: 'gid',
            key: 'gid',
            Xwidth: 190,
        },
        {
            title: 'Added by',
            dataIndex: 'addedBy',
            key: 'addedBy',
            width: 350,
        },
        {
            title: 'Date',
            dataIndex: 'creationDate',
            key: 'creationDate',
            width: 190,
            render: (text) => text ? new Date(text).toLocaleString() : '-'
        },
        {
            title: '',
            dataIndex: '',
            key: 'x',
            width: 70,
            fixed: 'right',
            className: 'admin-users-action',
            render: (text, record) => (
                <>
                    <NJIconButton
                        icon="delete"
                        onClick={(event) => {
                            console.log('Delete user', record);
                            setDeleteUserId(record.id);
                            setDeleteUserGid(record.gid);
                            setShowDeleteModal(true);
                            event.stopPropagation();
                        }}
                    />

                </>
            )
        },

    ];

    const handleLoadDataset = useCallback(async () => {
        // Prepare request
        const request = {
            action: 'load',
            dataType: dataType,
        }
        setIsLoading(true);
        try {
            const response = await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminDataManagement, request, userInfo);
            if (response && response.dataset) {
                setDataset(response.dataset);
            }
        } catch (error) {
            console.error('Error loading feedback data:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    }, [oktaAuth, userInfo]);

    useEffect(() => {
        if (active) {
            handleLoadDataset();
        }
    }, [active, handleLoadDataset]);

    const createNewUser = async (gid) => {
        // Prepare request
        console.log(userInfo);
        const request = {
            action: 'addAdminUser',
            user: {
                gid: gid.toUpperCase().trim(),
                addedBy: userInfo?.name
            }
        }
        setIsLoading(true);
        try {
            await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminDataManagement, request, userInfo);
            handleLoadDataset();
        } catch (error) {
            console.error('Error creating admin user:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    }

    const deleteUser = async (id) => {
        // Prepare request
        const request = {
            action: 'deleteAdminUser',
            id: id,
        }
        setIsLoading(true);
        try {
            await invokeLambda(oktaAuth, apiGatewayConfig.endpointAdminDataManagement, request, userInfo);
            handleLoadDataset();
        } catch (error) {
            console.error('Error deleting admin user:', error);
            displayNetworkError(error);
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            {isLoading && <Loading text="Loading feedback data..." />}
            <NJToastContainer type="full-width" />
            <ModalAddUser
                isOpen={showAddModal}
                handleAddUser={(gid) => { setShowAddModal(false); createNewUser(gid); }}
                handleCancel={() => { setShowAddModal(false) }} />
            <ModalConfirmDelete
                isOpen={showDeleteModal}
                id={deleteUserId}
                gid={deleteUserGid}
                handleDelete={(id) => { setShowDeleteModal(false); deleteUser(id); }}
                handleCancel={() => { setShowDeleteModal(false) }}
            />
            <div className='admin-data-content'>
                <div className='admin-feedback-count'>
                    <Flex justify='right'>
                        <NJButton
                            icon="person_add_alt"
                            label="Add Admin User"
                            onClick={() => { setShowAddModal(true) }}
                        />
                    </Flex>
                </div>
                <div className='admin-data-grey-box'>
                    <div className='admin-data-table'>
                        <Table
                            dataSource={dataset}
                            rowKey={(record) => record.id || Math.random().toString()}
                            pagination={false}
                            columns={usersColumns}
                            sticky={{
                                offsetHeader: 0,
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminUsers;
